import { render } from "./SizeSlider.vue?vue&type=template&id=4ffbf430&scoped=true"
import script from "./SizeSlider.vue?vue&type=script&lang=js"
export * from "./SizeSlider.vue?vue&type=script&lang=js"

import "./SizeSlider.vue?vue&type=style&index=0&id=4ffbf430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffbf430"]])

export default __exports__